import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/**
 * Building blocks of the full-screen Job Details window (Service Schedule):
 * a titled section card and a compact label/value row.
 */

export const JobDetailsSection = ({ title, action = null, children, sx = {} }) => (
  <Paper variant="outlined" sx={{ p: { xs: 2, md: 2.5 }, mb: 2, ...sx }}>
    {(title || action) && (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1.5, minHeight: 28 }}>
        <Typography variant="overline" sx={{ fontWeight: 700, color: 'text.secondary', lineHeight: 1.5 }}>
          {title}
        </Typography>
        {action}
      </Box>
    )}
    {children}
  </Paper>
);

/** One "Label   value" line; `value` may be any node. Nothing when value is empty unless `placeholder`. */
export const InfoRow = ({ label, value, placeholder = null, icon = null }) => {
  if ((value === null || value === undefined || value === '') && placeholder === null) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, py: 0.5 }}>
      <Typography variant="body2" color="text.secondary" sx={{ width: { xs: 84, sm: 110 }, flexShrink: 0 }}>
        {label}
      </Typography>
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
        {value === null || value === undefined || value === ''
          ? <Typography variant="body2" color="text.disabled">{placeholder}</Typography>
          : typeof value === 'string' || typeof value === 'number'
            ? <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>{value}</Typography>
            : value}
        {icon}
      </Box>
    </Box>
  );
};
